import { Component, OnInit, TemplateRef } from '@angular/core';
import moment from 'moment';
import { AppComponentName, Event, Message, MessageActionType, MessageNoteCategory, MessageType, UserGroup } from '@models';
import { ToastrService } from 'ngx-toastr';
import { EventMapper } from '../trigger.mapping';
import { TriggerService } from '../trigger.service';
import { AppMessageService } from '@services/message.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonShared } from 'app/shared/classes/common';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from 'app/components/messages/changelog-notes/changelognotes.components';

export interface EditEventConditionThresholdParams {
  event: Event;
  username: string;
  associatedUserGroups: UserGroup[];
  quickEditThreshold: number;
}

@Component({
  standalone: false,
  selector: 'app-edit-event-condition-threshold',
  templateUrl: './edit-event-condition-threshold.component.html',
  styleUrls: ['./edit-event-condition-threshold.component.scss']
})

export class EditEventConditionThresholdComponent implements OnInit, EditEventConditionThresholdParams {

  public common = new CommonShared();

  modalDragOn: boolean = false;

  event: Event;
  username: string;
  associatedUserGroups: UserGroup[];
  quickEditThreshold: number;
  changeLogNotes: string;

  private selectedUserGroup: UserGroup;
  private eventMapper = new EventMapper();
  private logModalRef: BsModalRef;

  constructor(public bsModalRef: BsModalRef,
              private toastr: ToastrService,
              private _appMessageService: AppMessageService,
              private modalService: BsModalService,
              private _triggerService: TriggerService) { }

  ngOnInit(): void {
  }

  
  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';

    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: this.event.userGroupID,
      category: MessageNoteCategory.EventThreshold
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }

  
  quickEditDecreaseThreshold(): void {
    this.quickEditThreshold--;
  }

  quickEditIncreaseThreshold(): void {
    this.quickEditThreshold++;
  }

  updateEventCondition(): void {
    this.bsModalRef.hide();

    this.event.userName = this.username;
    if (this.event.userGroupID == null) {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    } else {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == this.event.userGroupID);
      this.event.userGroupID = this.selectedUserGroup.id;
      this.event.userGroup = this.selectedUserGroup.name;
    }

    let originalThreshold: number;
    if (this.event.sensorConditions != null && this.event.sensorConditions.length > 0) {
      originalThreshold = this.event.sensorConditions[0].threshold;
      this.event.sensorConditions[0].threshold = this.quickEditThreshold;
    } else {
      this.toastr.warning('Unable to save threshold change.');
      return;
    }

    const eventInfo = this.eventMapper.mapEvent2EventInfo(this.event);
    eventInfo.modifiedDate = moment().utc().toDate();
    this.createMessageData(MessageActionType.Edited, this.event, this.common.compareProperty('SensorCond.1.threshold', this.common.prepareProperty4String(originalThreshold), this.common.prepareProperty4String(this.quickEditThreshold)));

    this._triggerService.updateEvent(eventInfo, '', this.username).subscribe(
      results => {
        if (results != null) {
          this.toastr.success('Success');
        } else {
          this.toastr.warning('Error updating event');
          this.event.sensorConditions[0].threshold = originalThreshold;
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating event');
        this.event.sensorConditions[0].threshold = originalThreshold;
      });
  }


  private createMessageData(msgActionType: MessageActionType, event: Event, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.EventAndActions,
      actionType: msgActionType,
      appComponentItem: event.name,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: event.userGroupID
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


}
